export const withoutPlan = [
  'Searching for drills the night before',
  'Guessing the order of skills',
  'Improvising the layout while the class waits',
  'Long lines in large groups',
  'Unsure what to look for in each pupil',
];

export const withPlan = [
  'Twelve lessons in a clear sequence',
  'Diagrams that show the setup',
  'Instructions you can say as written',
  'Options for large and mixed-level groups',
  'Simple observation and recording sheets',
];
